import axios from "../../config/axiosConfig";
import { getSubJobReturnTransactionTakaNo } from './sub-job-return-transaction-actions';
import { getProductions } from './production-entry-actions';
import { getProductionTransaction, getProductionTransactionTakaNo } from './production-transaction-actions';
import { CREATE_SUB_JOB_RETURN, GET_SUB_JOB_RETURNS, SUB_JOB_RETURN_REQUEST, UPDATE_SUB_JOB_RETURN, DELETE_SUB_JOB_RETURN, SUB_JOB_RETURN_REQUEST_FAILURE } from "../types";

export const getSubJobReturns = () => {
  return async (dispatch, getState) => {
    try {
      dispatch({ type: SUB_JOB_RETURN_REQUEST });
      const { auth } = getState();
      let params = { finyearId: auth.finyear?.id, companyId: auth.company?.id, customerId: auth?.user?.Customer_Id };
      return axios.get("/sub-job-return/getAll", { params }).then((response) => {
        if (response.data) {
          dispatch({ type: GET_SUB_JOB_RETURNS, payload: response.data });
        }
      }).catch((error) => {
        console.error(error);
        dispatch({ type: SUB_JOB_RETURN_REQUEST_FAILURE, error: error.message });  
      });
    } catch (error) {
      console.error(error);
      dispatch({ type: SUB_JOB_RETURN_REQUEST_FAILURE, error: error.message });
    }
  };
};

export const createSubJobReturn = (subJobReturn) => {
  return async (dispatch, getState) => {
    try {
      const { auth } = getState();
      dispatch({ type: SUB_JOB_RETURN_REQUEST });
      const newSubJobReturn = {
        ...subJobReturn
      };
      return axios.post("/sub-job-return/add", newSubJobReturn,
        { params: { userId: auth.user?.id, companyId: auth.company?.id, finyearId: auth.finyear?.id, customerId: auth?.user?.Customer_Id } }
      ).then((response) => {
        if (response.data) {
          dispatch({ type: CREATE_SUB_JOB_RETURN, payload: response.data });
          dispatch(getSubJobReturnTransactionTakaNo());
          dispatch(getProductions());
          dispatch(getProductionTransaction());
          dispatch(getProductionTransactionTakaNo());
        } else {
          dispatch({
            type: SUB_JOB_RETURN_REQUEST_FAILURE,
            error: "Sub Job Return create failed.",
          });
        }
        return response;
      }).catch((error) => {
        console.error(error);
        dispatch({ type: SUB_JOB_RETURN_REQUEST_FAILURE, error: error.message });
        throw error;
      });
    } catch (error) {
      console.error(error);
      dispatch({ type: SUB_JOB_RETURN_REQUEST_FAILURE, error: error.message });
      throw error;
    }
  };
};

export const updateSubJobReturn = (id, data) => {
  return async (dispatch, getState) => {
    try {
      dispatch({ type: SUB_JOB_RETURN_REQUEST });
      const { auth } = getState();
      return axios.put("/sub-job-return/update", { id, data },
        { params: { 
            userId: auth.user?.id,
            companyId: data.Company_Id || auth.company?.id,
            finyearId: data.Finyear_Id || auth.finyear?.id,
            customerId: data.Customer_Id || auth?.user?.Customer_Id,
          }
        }
      ).then((response) => {
        if (response.data) {
          dispatch({
            type: UPDATE_SUB_JOB_RETURN,
            payload: { id, data: response.data },
          });
          dispatch(getSubJobReturnTransactionTakaNo());
          dispatch(getProductions());
          dispatch(getProductionTransaction());
          dispatch(getProductionTransactionTakaNo());
        } else {
          dispatch({
            type: SUB_JOB_RETURN_REQUEST_FAILURE,
            error: "Sub Job Return update failed.",
          });
        }
        return response;
      }).catch((error) => {
        console.error(error);
        dispatch({ type: SUB_JOB_RETURN_REQUEST_FAILURE, error: error.message });
        throw error;
      });
    } catch (error) {
      console.error(error);
      dispatch({ type: SUB_JOB_RETURN_REQUEST_FAILURE, error: error.message });
      throw error;
    }
  };
};

export const deleteSubJobReturn = (id) => {
  return async (dispatch, getState) => {
    try {
      dispatch({ type: SUB_JOB_RETURN_REQUEST });
      const { auth } = getState();
      return axios.delete(`/sub-job-return/delete/${id}`, { params: { userId: auth.user?.id }}).then((response) => {
        if (response.data) {
          dispatch({ type: DELETE_SUB_JOB_RETURN, id: id });
          dispatch(getSubJobReturnTransactionTakaNo());
          dispatch(getProductions());
          dispatch(getProductionTransaction());
          dispatch(getProductionTransactionTakaNo());
        }
        return response;
      }).catch((error) => {
        console.error(error);
        dispatch({ type: SUB_JOB_RETURN_REQUEST_FAILURE, error: error.message });
        throw error;
      });
    } catch (error) {
      console.error(error);
      dispatch({ type: SUB_JOB_RETURN_REQUEST_FAILURE, error: error.message });
      throw error;
    }
  };
};
